import React, { Component } from 'react';
import ButtonToTop from '../ButtonToTop/ButtonToTop';
import './Footer.css';
import { Link } from 'react-router';

class Footer extends Component {

    constructor(props) {
        super(props);
        this.state = {

        };

    }

    componentDidMount() {

    }

    componentWillUnmount() {

    }

    componentDidUpdate() {

    };

    handleClick = (type) => {
        //console.log(("click footer - type: " + type);
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(0, type, "footer");
        }
    };


  render() {
    return (
      <div className="Footer">
          <div className="Background"></div>
          <div className="NavigationContainer">
                  <div className="AdressRow row">
                      <div className="ColAdress col-lg-3 col-lg-offset-0 col-md-4 col-md-offset-2 col-sm-6 col-xs-12">
                          <h3>Adresse <i className="Icon material-icons">my_location</i></h3>
                          <p>
                              Landhotel Schorssow<br/>Am Haussee 4<br/>17166 Schorssow
                          </p>
                      </div>
                      <div className="ColAdress col-lg-3 col-lg-offset-0 col-md-4 col-md-offset-1 col-sm-6 col-xs-12">
                          <h3><i className="Icon material-icons">phone</i> Kontakt</h3>
                          <p>
                              Tel: +49 3 99 33 / 7 06 45<br/>
                              Fax: +49 3 99 33 / 7 03 27
                          </p>
                      </div>
                      <div className="clearfix hidden-lg"/>
                      <div className="ColAdress col-lg-4 col-lg-offset-0 col-md-4 col-md-offset-2 col-sm-6 col-xs-12">
                          <h3>Email &amp; Web<i className="Icon material-icons">mail_outline</i></h3>
                          <p>
                              <a href="mailto:willkommen@landhotel-schorssow.de?subject=Kontaktaufnahme Landhotel Schorssow">willkommen@landhotel-schorssow.de</a>
                              <br/>
                              <a href="https://www.landhotel-schorssow.de">www.landhotel-schorssow.de</a>
                          </p>
                      </div>

                      <div className="ColAdress col-lg-2 col-lg-offset-0 col-md-4 col-md-offset-1 col-sm-6 col-xs-12">
                          <h3>Weiteres<i className="Icon material-icons">more</i></h3>
                          <p>
                              <Link to="/sonstiges/impressum">Impressum</Link><br/>
                              <Link to="/sonstiges/datenschutz">Datenschutz</Link><br/>
                              <Link to="/sonstiges/jobs">Jobangebote</Link><br/>
                              <Link to="/sonstiges/kontakt">Kontakt</Link><br/>
                              <Link href="https://www.google.de/maps/place/Landhotel+Schorssow/@53.680129,12.5638564,17z/data=!3m1!4b1!4m5!3m4!1s0x47ac0ea424cb4ff3:0x35480018769d6d65!8m2!3d53.680129!4d12.5660504" target="_blank">Routenplaner</Link>
                          </p>
                      </div>
                  </div>
              <ButtonToTop></ButtonToTop>
                  <p><i className="material-icons">copyright</i>Landhotel Schorssow 2017</p>
          </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js